export const DESKTOP_HEADER_HEIGHT = '50px';
export const DESKTOP_HIDE_HEADER_HEIGHT = '-52px';
export const DESKTOP_HEADER_HEIGHT_NUMERIC = 50;

export const MOBILE_HEADER_HEIGHT = '50px';

export const NEW_NAV_MOBILE_HEADER_HEIGHT = '58px';
export const NEW_NAV_MOBILE_HIDE_HEADER_HEIGHT = '-61px';
export const NEW_NAV_MOBILE_HEADER_HEIGHT_NUMERIC = 58;

export const NAV_PDP_MOBILE_HEADER_HEIGHT = '50px';

export const DEFAULT_ITEMS_COUNT = 315299;
